module.exports = __webpack_public_path__ + "static/img/yingxiaotuiguang.3585ef00.png";